module.exports = __webpack_public_path__ + "img/897631f.jpg";